"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInfoSection = void 0;
function buildInfoSection(section) {
    return {
        type: 'info',
        description: section.description || 'Patient Info Section',
        subsections: [
            {
                subtitle: 'Aetonix ID',
                displayType: 'ObjectId',
                dataAccessor: ['_id'],
            },
            {
                subtitle: 'Patient Number',
                displayType: 'text',
                dataAccessor: ['patientNumber'],
            },
            {
                subtitle: 'Health Card Number',
                displayType: 'text',
                dataAccessor: ['healthCardNumber'],
            },
            {
                subtitle: 'First Name',
                displayType: 'text',
                dataAccessor: ['fname'],
            },
            {
                subtitle: 'Surname',
                displayType: 'text',
                dataAccessor: ['lname'],
            },
            {
                subtitle: 'Inactive',
                displayType: 'text',
                dataAccessor: ['inactive'],
            },
            {
                subtitle: 'Phone Number',
                displayType: 'text',
                dataAccessor: ['phone'],
            },
            {
                subtitle: 'Date of Birth',
                displayType: 'text',
                dataAccessor: ['dob'],
            },
            {
                subtitle: 'Address',
                displayType: 'text',
                dataAccessor: ['address'],
            },
            {
                subtitle: 'Street',
                displayType: 'text',
                dataAccessor: ['street'],
            },
            {
                subtitle: 'City',
                displayType: 'text',
                dataAccessor: ['city'],
            },
            {
                subtitle: 'Province',
                displayType: 'text',
                dataAccessor: ['province'],
            },
            {
                subtitle: 'Postal',
                displayType: 'text',
                dataAccessor: ['postal'],
            },
            {
                subtitle: 'Group',
                displayType: 'text',
                dataAccessor: ['orgGroup'],
            },
            {
                subtitle: 'Organization',
                displayType: 'text',
                dataAccessor: ['organization'],
            },
        ],
    };
}
exports.buildInfoSection = buildInfoSection;
//# sourceMappingURL=patientInfoSection.js.map